import { render, staticRenderFns } from "./PrivilegeAction.vue?vue&type=template&id=710d8572&scoped=true&"
import script from "./PrivilegeAction.vue?vue&type=script&lang=js&"
export * from "./PrivilegeAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710d8572",
  null
  
)

export default component.exports